import { useContext, useEffect } from 'react';
import { useSearchParams } from '@shared/hooks';
import { useStatusesTableColumns } from './use-statuses-table-columns';
import { StatusesTableContext } from '../../context';

export const useStatusesTable = () => {
  const { handleFetch } = useContext(StatusesTableContext);
  const columns = useStatusesTableColumns();
  const { searchParams, remove } = useSearchParams<{ reFetchStatusesTable?: string }>();

  useEffect(() => {
    (async () => {
      if (searchParams.reFetchStatusesTable) {
        remove.current('reFetchStatusesTable');
        await handleFetch();
      }
    })();
  }, [handleFetch, remove, searchParams.reFetchStatusesTable]);

  return { columns };
};
